import { render, staticRenderFns } from "./CreateGoodsPage.vue?vue&type=template&id=73f619ea&scoped=true&lang=pug&"
import script from "./CreateGoodsPage.vue?vue&type=script&lang=ts&"
export * from "./CreateGoodsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGoodsPage.vue?vue&type=style&index=0&id=73f619ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f619ea",
  null
  
)

export default component.exports